import UserService from '@/api/UserService'

// initial state
const state = {
  users: [],
  user_logs: [],
}

// getters
const getters = {
  getUsers: state => state.users,
  getUserLogs: state => state.user_logs,
}

// mutations
const mutations = {
  setUsers (state, data) {
    state.users = data
  },
  setUserLogs (state, data) {
    state.user_logs = data
  },
}

// actions
const actions = {
  async getUsers ({ commit }, param) {
    var result

    // check this api is still loading or not
    if (this.state.app.loadinglist.indexOf('getUsers') >= 0) return

    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)
      // add loadinglist
      this.dispatch('addLoadinglist', 'getUsers')

      let response = await UserService.getAll(param)

      // stop loading
      this.dispatch('Loading', false)
      // remove loadinglist
      this.dispatch('removeLoadinglist', 'getUsers')

      result = response.data

      if (result.success) {
        commit('setUsers', result.data)
      } else {
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }
    return result
  },
  async getUserLogs ({ commit }, data) {
    var result

    // check this api is still loading or not
    if (this.state.app.loadinglist.indexOf('getUserLogs') >= 0) return

    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)
      // add loadinglist
      this.dispatch('addLoadinglist', 'getUserLogs')

      let response = await UserService.getLogs(data)

      // stop loading
      this.dispatch('Loading', false)
      // remove loadinglist
      this.dispatch('removeLoadinglist', 'getUserLogs')

      result = response.data

      if (result.success) {
        commit('setUserLogs', result.data)
      } else {
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }
    return result
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
}



// WEBPACK FOOTER //
// ./src/store/modules/User.js